import { useState } from 'react';
import SearchModal from './SearchModal';

export default function SearchButton() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleOpenSearch = () => {
    setIsSearchOpen(true);
  };

  const handleCloseSearch = () => {
    setIsSearchOpen(false);
  };

  return (
    <>
      <button
        onClick={handleOpenSearch}
        className="relative p-2 text-gray-600 hover:text-healthy-green hover:bg-green-50 rounded-full transition-colors"
        title="Search"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </button>

      <SearchModal isOpen={isSearchOpen} onClose={handleCloseSearch} />
    </>
  );
}